import * as React from "react";
import { cn } from "@/lib/utils";

export interface RadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: "default" | "lg";
  label?: string;
  id?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ 
    className, 
    size = "default", 
    label, 
    id, 
    name, 
    value, 
    checked, 
    disabled, 
    onChange,
    ...props 
  }, ref) => {
    const getSizeClasses = () => {
      switch (size) {
        case "lg":
          return "wl-radio-container-lg";
        default:
          return "";
      }
    };

    return (
      <label 
        htmlFor={id} 
        className={cn("wl-radio-container", getSizeClasses(), className)}
      >
        <input
          ref={ref}
          id={id}
          type="radio"
          name={name}
          value={value}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className="wl-input-radio"
          {...props}
        />
        <div className="wl-radio-circle" />
        {label && <span>{label}</span>}
      </label>
    );
  }
);

Radio.displayName = "Radio";

export { Radio };
